import React from "react";
import { OrganizationServicesOffered } from "@common/types/organization";
import { FiltersTypes } from "@common/types/filters/general";
import { servicesOfferedLabels } from "@components/entity/constants";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const ServicesFilterLabel: React.FC<Props> = ({ filters }) => {
    const { services } = filters;

    if (!services || services.length === 0) {
        return null;
    }

    const labels = services.map(
        (service) =>
            servicesOfferedLabels[service as OrganizationServicesOffered],
    );
    return formatFilterLabel(labels);
};
